import {staffApi} from './staffApi';

// Progress remains in the open editor after a failed request. Creation keys
// are reused; publication happens only after forms and variants are prepared.
export async function createServiceDraft(draft,progress) {
    if(!progress.key)progress.key=crypto.randomUUID();
    if(!progress.parent) {
        const result=await staffApi.menuCreate('services',{request_id:progress.key,name:draft.name.trim(),description:draft.description,categoryId:Number(draft.category),providers:[Number(draft.provider)],price:Number(draft.price),duration:Number(draft.minutes)*60,deposit:Number(draft.deposit),depositPayment:draft.depositType,status:'hidden'});
        progress.parent=result.service.id;
    }
    const parent=progress.parent;
    const assigned=(await staffApi.listServiceForms(parent)).assignments || [];
    for(const form of draft.forms) {
        if(!assigned.some(a=>a.form_template_id===form.form_template_id)) await staffApi.assignFormToService(parent,form);
    }
    if(!progress.variants)progress.variants=[];
    for(let i=0;i<draft.variants.length;i++) {
        if(!progress.variants[i])progress.variants[i]={key:crypto.randomUUID()};
        const saved=progress.variants[i],v=draft.variants[i];
        if(!saved.id) {
            const result=await staffApi.createVariant(parent,{request_id:saved.key,label:v.name.trim(),price:Number(v.price),duration:Number(v.minutes)*60});
            saved.id=result.service.id;
        }
    }
    const ids=[parent,...progress.variants.map(v=>v.id)];
    if((draft.baseLabel || draft.variants.length) && !progress.grouped) {
        const doc=await staffApi.catalogue(),rules={...doc.rules};
        rules[parent]={...rules[parent],display_name:draft.name.trim(),option_label:draft.baseLabel.trim(),pricing_mode:'from',display_order:0};
        ids.slice(1).forEach((id,i)=>{rules[id]={...rules[id],display_order:i+1};});
        await staffApi.saveCatalogue({revision:doc.revision,rules});progress.grouped=true;
    }
    for(const id of ids) await staffApi.updateService(id,{status:draft.status});
    return parent;
}
